"use client";

import { ClerkProvider, useAuth } from "@clerk/nextjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { Toaster } from "sonner";
import { FloatingOrgSwitcher } from "@/components/FloatingOrgSwitcher";
import { PostHogProvider } from "@/components/PostHogProvider";
import { setTokenGetter } from "@/lib/api-client";

function AuthBridge({ children }: { children: React.ReactNode }) {
  const { getToken } = useAuth();
  // Set synchronously during render (not in useEffect) so the token getter
  // is available before any child component's first fetch fires.
  setTokenGetter(getToken);
  return <>{children}</>;
}

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  return (
    <ClerkProvider>
      <AuthBridge>
        <PostHogProvider>
          <QueryClientProvider client={queryClient}>
            {children}
            <FloatingOrgSwitcher />
            <Toaster position="bottom-right" richColors closeButton />
          </QueryClientProvider>
        </PostHogProvider>
      </AuthBridge>
    </ClerkProvider>
  );
}
